export default [
    {
        path: 'relatorio-historico-papel-lotacao',
        component: () => import(
            /* webpackChunkName: 'administracao-relatorio-historico-papel-lotacao' */
            '@/views/administracao/relatorio-historico-papel-lotacao/Index'
        ),
        redirect: 'relatorio-historico-papel-lotacao/index',
        children: [
            {
                name: 'administracao-relatorio-historico-papel-lotacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-relatorio-historico-papel-lotacao' */
                    '@/views/administracao/relatorio-historico-papel-lotacao/List'
                ),
            },
        ]
    }
]